import React from 'react';
interface SkillCategory {
  title: string;
  skills: string[];
}
interface SkillsSectionProps {
  skills: SkillCategory[];
}
const SkillsSection = ({
  skills
}: SkillsSectionProps) => {
  return <div className="py-16 bg-gray-900" data-id="element-175">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-176">
        <div className="text-center mb-12" data-id="element-177">
          <div className="relative inline-block" data-id="element-178">
            <h2 className="text-3xl font-bold text-white" data-id="element-179">
              Skillsets at a Glance
            </h2>
            <div className="absolute -bottom-2 left-0 w-full h-1 bg-gradient-to-r from-indigo-500 via-purple-500 to-blue-500 rounded-full" data-id="element-180"></div>
          </div>
          <p className="mt-4 text-lg text-gray-300" data-id="element-181">
            A comprehensive toolkit built from 7+ years of product experience
          </p>
        </div>
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8" data-id="element-182">
          {skills.map((category, index) => <div key={index} className="bg-gray-800 p-6 rounded-lg shadow-md hover:shadow-lg transition-shadow hover:shadow-indigo-900/20 border border-gray-700" data-id="element-183">
              <h3 className="text-xl font-semibold text-white mb-4 border-b border-gray-700 pb-2" data-id="element-184">
                {category.title}
              </h3>
              <ul className="space-y-2" data-id="element-185">
                {category.skills.map((skill, i) => <li key={i} className="flex items-center" data-id="element-186">
                    <div className="h-2 w-2 bg-indigo-500 rounded-full mr-2" data-id="element-187"></div>
                    <span className="text-gray-300" data-id="element-188">{skill}</span>
                  </li>)}
              </ul>
            </div>)}
        </div>
      </div>
    </div>;
};
export default SkillsSection;